import axios from 'axios'
import { METHOD } from './constant'
import { getUserToken } from '@/utils/auth'

export const apiGetNonAuth = (URL, params) => axios({
  url: URL,
  method: METHOD.GET,
  params
})

export const apiPostNonAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.POST,
  data
})

export const apiGetAuth = (URL, params) => axios({
  url: URL,
  method: METHOD.GET,
  params,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiGetAuthWithCustomHeadersResponseType = (URL, params) => axios({
  url: URL,
  method: METHOD.GET,
  params,
  headers: {
    "Content-Type": "application/octet-stream",
    Authorization: getUserToken()
  },
  responseType: 'arraybuffer'
})

export const apiPostAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.POST,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiPostAuthWithConfig = (URL, data, config) => axios({
  url: URL,
  method: METHOD.POST,
  data,
  headers: {
    Authorization: getUserToken()
  },
  ...config
})

export const apiPostAuthWithResponseType = (URL, responseType, data) => axios({
  url: URL,
  method: METHOD.POST,
  data,
  headers: {
    Authorization: getUserToken()
  },
  responseType
})

export const apiPutAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.PUT,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiPutMultipartAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.PUT,
  data,
  headers: {
    Authorization: getUserToken(),
    'Content-Type': 'multipart/form-data'
  }
})

export const apiPatchAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.PATCH,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiDeleteAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.DELETE,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiPostMultipartAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.POST,
  data,
  headers: {
    Authorization: getUserToken(),
    'Content-Type': 'multipart/form-data'
  }
})
